module.exports = __webpack_public_path__ + "img/72_22.a084ba14.png";